import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/AIFeedback/Index'

const AIFeedback = () => {
  return (
    <div className='page-main'>
        <Header name = {["AI Feedback"]}/>
        <Index />
    </div>
  )
}
export default AIFeedback
